// @index('./*.ts', pp => `export * from '${pp.path}';`)
export * from './IAdvancedSort';
export * from './IAllocations';
export * from './IAllocationsValues';
export * from './IBaseEntity';
export * from './IDocument';
export * from './IDocumentWithInferred';
export * from './IEntity';
export * from './IEntityEntity';
export * from './IExtendedEntity';
export * from './IFetchEntitiesOptions';
export * from './IFetchEntitiesOptionsSearch';
export * from './IFetchEntitiesOptionsSearchStrip';
export * from './IFundGetFiltersRequest';
export * from './IFundGetFiltersResponse';
export * from './IFundManager';
export * from './IFundManagersListResponse';
export * from './IIsInferred';
export * from './IJoinDocSearch';
export * from './IJoinSpec';
export * from './IJsonValues';
export * from './ILinkedEntity';
export * from './IListCommentariesRequestBody';
export * from './IMessage';
export * from './IPickList';
export * from './IPickListDeleteParams';
export * from './IPickListGetParams';
export * from './IPickListListRequest';
export * from './IPickListListResponse';
export * from './IPickListOption';
export * from './IPickListOptionDeleteParams';
export * from './IPickListOptionGetParams';
export * from './IPickListOptionGetResponse';
export * from './IPickListOptionListRequest';
export * from './IPickListOptionListResponse';
export * from './IPickListOptionQuery';
export * from './IPickListOptionUpsertRequest';
export * from './IPickListOptionUpsertResponse';
export * from './IPickListUpsertRequest';
export * from './IPickListUpsertResponse';
export * from './ISearch';
export * from './ISearchEntities';
export * from './ISearchEntityRequest';
export * from './ISearchEntityRequestOptions';
export * from './ISearchEntityRequestQueries';
export * from './ISearchQueries';
export * from './ISearchTranslationsRequestBody';
export * from './ISearchTranslationsResponseBody';
export * from './ISort';
export * from './ISortQueries';
export * from './IStatistics';
export * from './IStatisticsValue';
export * from './ITimeseries';
export * from './ITimeseriesValues';
export * from './ITransaction';
export * from './ITransactionFilterItem';
export * from './ITransactionFilters';
export * from './ITransactionGetFiltersRequest';
export * from './ITransactionGetFiltersResponse';
export * from './ITransactionResponse';
export * from './ITransactionSearch';
export * from './ITransactionsInclude';
export * from './ITransactionTextSearch';
export * from './ITransactionValue';
export * from './ITranslationMapping';
export * from './MessageType';
export * from './TCommentaryType';
export * from './TDocMetaValue';
export * from './TDocProperty';
export * from './TEntityPropertiesPub';
export * from './TFilterProperties';
export * from './TFundGetFilters';
export * from './TFundlist';
export * from './TFundlistExclusion';
export * from './TInferredObject';
export * from './TListCommentariesResponseBody';
export * from './TMetaObject';
export * from './TPickListGetResponse';
export * from './TPropertyCode';
export * from './TTransactionMatchType';
